import { render, staticRenderFns } from "./product-compliance.vue?vue&type=template&id=c1d18e98&scoped=true&"
import script from "./product-compliance.vue?vue&type=script&lang=js&"
export * from "./product-compliance.vue?vue&type=script&lang=js&"
import style0 from "./product-compliance.vue?vue&type=style&index=0&id=c1d18e98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d18e98",
  null
  
)

export default component.exports